// extracted by mini-css-extract-plugin
module.exports = {"life-bank-sample-table":"life-bank-sample-table-e0b29e7c4cd2d5d5e77b2fd16c8f914d"};